import insertTextNodes from './insertTextNodes';

export default (params) => {
  const { index, editor, incomingBlock } = params;

  // cursor position is in between
  if (index > 0) {
    // split block at cursor position
    editor.splitBlock();
  }

  // insert incoming block text nodes in focus block
  insertTextNodes(incomingBlock, editor);
  return true;
};
